(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["activities"]) return;
  try {
    
  // Activities slider: scroll-snap track driven by arrows; dots are decorative position indicators
  document.querySelectorAll('.activities-slider').forEach((slider) => {
    const track = slider.querySelector('.slider-track');
    const slideCount = track.children.length;
    const dots = Array.from(slider.querySelectorAll('.slider-dots span'));
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    const current = () => Math.round(track.scrollLeft / track.clientWidth);

    const goTo = (index) => {
      const target = (index + slideCount) % slideCount;
      track.scrollTo({
        left: target * track.clientWidth,
        behavior: reducedMotion.matches ? 'auto' : 'smooth',
      });
    };

    slider.querySelector('[data-slide="prev"]').addEventListener('click', () => goTo(current() - 1));
    slider.querySelector('[data-slide="next"]').addEventListener('click', () => goTo(current() + 1));

    track.addEventListener(
      'scroll',
      () => {
        const index = current();
        dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
      },
      { passive: true }
    );
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  // Mobile navigation drawer (native <dialog> gives us focus trapping + Escape)
  const menuButton = document.getElementById('menu-button');
  const menu = document.getElementById('menu');

  if (menuButton && menu) {
    const closeButton = menu.querySelector('button');

    menuButton.addEventListener('click', () => {
      menu.showModal();
      menuButton.setAttribute('aria-expanded', 'true');
    });

    closeButton.addEventListener('click', () => menu.close());

    // Clicks on the dimmed backdrop target the dialog itself but land
    // outside its box — close the drawer when that happens.
    menu.addEventListener('click', (event) => {
      if (event.target !== menu) return;
      const box = menu.getBoundingClientRect();
      const insidePanel =
        event.clientX >= box.left &&
        event.clientX <= box.right &&
        event.clientY >= box.top &&
        event.clientY <= box.bottom;
      if (!insidePanel) menu.close();
    });

    menu.addEventListener('close', () => {
      menuButton.setAttribute('aria-expanded', 'false');
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  // Product gallery: thumbnails reveal the matching full-size frame
  document.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
    const frames = gallery.querySelectorAll('[data-media]');
    const thumbs = gallery.querySelectorAll('[data-media-target]');

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const index = thumb.dataset.mediaTarget;

        frames.forEach((frame) => {
          frame.hidden = frame.dataset.media !== index;
        });

        thumbs.forEach((other) => {
          const active = other === thumb;
          other.classList.toggle('is-active', active);
          other.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["splash-info"]) return;
  try {
    
  // Splash room slider: scroll-snap track driven by arrows; dots are decorative position indicators
  document.querySelectorAll('.splash-slider').forEach((slider) => {
    const track = slider.querySelector('.slider-track');
    const slideCount = track.children.length;
    const dots = Array.from(slider.querySelectorAll('.slider-dots span'));
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    const current = () => Math.round(track.scrollLeft / track.clientWidth);

    const goTo = (index) => {
      const target = (index + slideCount) % slideCount;
      track.scrollTo({
        left: target * track.clientWidth,
        behavior: reducedMotion.matches ? 'auto' : 'smooth',
      });
    };

    slider.querySelector('[data-slide="prev"]').addEventListener('click', () => goTo(current() - 1));
    slider.querySelector('[data-slide="next"]').addEventListener('click', () => goTo(current() + 1));

    track.addEventListener(
      'scroll',
      () => {
        const index = current();
        dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
      },
      { passive: true }
    );
  });

  } catch(e) { console.error(e); }
})();
})();
